import React from "react";
import { Field } from "react-final-form";
import { TextInput } from "../../../components/inputs/final_form/TextInput";
import { adminApi as api } from "../../../util/api";
import { ImportModal } from "../../components/ImportModal";
import { required } from "../../../util/validators";
import { snakifyKeys } from "../../../util/helpers";

export const ImportPayorNotesModal = ({ onImport, payorId, ...rest }) => {
  const handleImport = async (values) => {
    const params = {
      payorId: values.payorId,
      file: {
        bytes: values.file,
      },
    };

    const res = await api.post(`/admin/payor_notes/import.json`, snakifyKeys(params));

    if (onImport) {
      onImport(res.data?.meta?.message, res.data?.meta?.error_details);
    }
  };

  return (
    <ImportModal
      buttonProps={rest}
      onImport={handleImport}
      title="Add Payor Notes from CSV..."
      initialValues={{ payorId }}
      exampleDownloadPath="/admin/payor_notes/example"
    >
      {(formProps) => <Field component={TextInput} name="payorId" type="hidden" required validate={required} />}
    </ImportModal>
  );
};
